module.exports = __webpack_public_path__ + "static/img/cloud_img1.60f023c6.png";